import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/header.jpg'
import _imports_1 from '../assets/deutschrussin.jpg'
import _imports_2 from '../assets/sozialarbeiter.jpg'
import _imports_3 from '../assets/buergermeister.jpg'
import _imports_4 from '../assets/juedin.jpg'
import _imports_5 from '../assets/coronamoderator.jpg'
import _imports_6 from '../assets/kas.png'


const _withScopeId = n => (_pushScopeId("data-v-4fbd0c6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Wie gespalten ist Deutschland?", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Header Illustration",
    class: "header",
    src: _imports_0
  })
], -1))
const _hoisted_4 = { class: "cards" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Folge 1")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Folge 1: Die Deutschrussin und der Ukraine-Krieg",
  src: _imports_1
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Die Deutschrussin und der Ukraine-Krieg", -1))
const _hoisted_9 = { class: "card" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Folge 2")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Folge 2: Der Sozialarbeiter und das Bildungssystem",
  src: _imports_2
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Der Sozialarbeiter und das Bildungssystem", -1))
const _hoisted_13 = { class: "card" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Folge 3")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Folge 3: Der Bürgermeister und die Windräder",
  src: _imports_3
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Der Bürgermeister und die Windräder", -1))
const _hoisted_17 = { class: "card" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Folge 4")
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Folge 4: Die Jüdin und die Regenbogenfahne",
  src: _imports_4
}, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Die Jüdin und die Regenbogenfahne", -1))
const _hoisted_21 = { class: "card" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Folge 5")
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Folge 5: Der Corona-Moderator und das Seuchenparlament",
  src: _imports_5
}, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Der Corona-Moderator und das Seuchenparlament", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://das-journalismus-stipendium.de/",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Konrad-Adenauer-Stiftung Logo",
    src: _imports_6,
    class: "kas-logo"
  })
], -1))
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Folgen")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Team")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Impressum")
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://das-journalismus-stipendium.de/datenschutzerklaerung/"
  }, "Datenschutz")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (this.mitt.emit('loadFile', 0)))
          }, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'circle-play'],
              size: "2x"
            }),
            _hoisted_6
          ]),
          _hoisted_7,
          _hoisted_8
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (this.mitt.emit('loadFile', 1)))
          }, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'circle-play'],
              size: "2x"
            }),
            _hoisted_10
          ]),
          _hoisted_11,
          _hoisted_12
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (this.mitt.emit('loadFile', 2)))
          }, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'circle-play'],
              size: "2x"
            }),
            _hoisted_14
          ]),
          _hoisted_15,
          _hoisted_16
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (this.mitt.emit('loadFile', 3)))
          }, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'circle-play'],
              size: "2x"
            }),
            _hoisted_18
          ]),
          _hoisted_19,
          _hoisted_20
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (this.mitt.emit('loadFile', 4)))
          }, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'circle-play'],
              size: "2x"
            }),
            _hoisted_22
          ]),
          _hoisted_23,
          _hoisted_24
        ])
      ])
    ]),
    _hoisted_25,
    _createElementVNode("nav", null, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_26
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/team" }, {
            default: _withCtx(() => [
              _hoisted_27
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/impressum" }, {
            default: _withCtx(() => [
              _hoisted_28
            ]),
            _: 1
          })
        ]),
        _hoisted_29
      ])
    ])
  ], 64))
}